module.exports = __webpack_public_path__ + "img/eye.f77b3337.svg";